import React from 'react';
import { Button } from 'react-bootstrap';
import { TRADER_SEGMENT_OPTIONS } from '../../data/quizData';

/**
 * Gating question — does not affect behavioral scores.
 */
const QuizSegmentStep = ({ onSelect }) => {
  return (
    <div className="quiz-segment">
      <h2 className="h5 mb-2 quiz-segment-title">What best describes how you trade?</h2>
      <p className="quiz-segment-note small mb-4">
        This doesn’t affect your results — it just helps us know who’s in the room.
      </p>
      <div className="d-flex flex-column gap-2">
        {TRADER_SEGMENT_OPTIONS.map((opt) => (
          <Button
            key={opt.id}
            variant="outline-secondary"
            className="quiz-option text-center py-3 px-3"
            onClick={() => onSelect(opt.id)}
          >
            {opt.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuizSegmentStep;
